import { Tag } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import { useFieldValues } from '../.';
import { EnglishExamSchema } from '../../../../../pages/LoansForm/formSchemas';
import { EnglishTest } from '../../../types';
import DuolingoScore from './DuolingoScore';
import IeltsScore from './IeltsScore';
import PTEScore from './PTEScore';
import ToeflScore from './ToeflScore';

export const TEST_SCORE_MAP = new Map<string, () => JSX.Element>();
TEST_SCORE_MAP.set(EnglishTest.DUOLINGO.toString(), DuolingoScore);
TEST_SCORE_MAP.set(EnglishTest.PTE.toString(), PTEScore);
TEST_SCORE_MAP.set(EnglishTest.TOEFL.toString(), ToeflScore);
TEST_SCORE_MAP.set(EnglishTest.IELTS.toString(), IeltsScore);

const EnglishTestScoreFields = () => {
  const { englishTestType } = useFieldValues(['englishTestType']);
  const Component = TEST_SCORE_MAP.get(englishTestType);

  return <>{Component ? <Component /> : null}</>;
};

const EnglishTestScoreTag = () => {
  const { t } = useTranslation();
  const formValues = useFieldValues();
  const { englishTestType } = formValues;
  const { success: englishExamValid } = EnglishExamSchema(t).safeParse(formValues);

  return (
    <>
      {englishExamValid && englishTestType && (
        <Tag icon="fill" intent="positive" onClick={function Na() {}}>
          {englishTestType}
        </Tag>
      )}
    </>
  );
};

export { EnglishTestScoreFields, EnglishTestScoreTag };
